// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DevicesFranquias_ToggleWebsocketResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/devices_franquias/toggle_websocket
 *
 * Action endpoint — confirmation only; envelope `dados` is null.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type DevicesFranquias_ToggleWebsocketResponseDados = null;

export type DevicesFranquias_ToggleWebsocketResponse = ApiResponse<DevicesFranquias_ToggleWebsocketResponseDados>;

registerResponseContract('DevicesFranquias_ToggleWebsocketResponse', {})
